// @ts-check
import { formatQueryRange } from '../utils/common';
import { removeFalseyParams } from '../utils/queryParams';
import { handleApiCalls } from './axiosInstance';
import BaseAPI from './baseAPI';

class ReportTagsAPI extends BaseAPI {
  constructor() {
    super({ suffix: 'report-tags' });
  }

  /**
   * @param {{}} filters
   * @param {number} [pageNumber]
   * @param {number} [pageSize]
   * @param {string} [sort]
   */
  fetchReportTags = async (filters = {}, pageNumber, pageSize, sort) => {
    const range = formatQueryRange(pageNumber, pageSize);
    const params = removeFalseyParams({ ...filters, range, sort });

    const response = await handleApiCalls('get', this.baseUrl, {
      params: { ...params, range },
    });

    return response.data;
  };
}

export default ReportTagsAPI;
